import React from "react";
import PropTypes from "prop-types";
import { formatPrice } from "../helpers";
// CSSTransition uses CSS from css/_animations.styl
// the .styl is for Stylus (using that instead of SASS)
// see NOTES at bottom of this file, from Chapter 22, Animating React Components
import {TransitionGroup, CSSTransition} from "react-transition-group";

class Order extends React.Component {

    static propTypes = {
        fishes: PropTypes.object,
        order: PropTypes.object,
        removeFromOrder: PropTypes.func
    };

    renderOrder = (key) => {
        const fish = this.props.fishes[key];
        const count = this.props.order[key];
        const isAvailable = fish && fish.status === 'available';
        const TransitionOptions = {
            classNames: "order",
            key: key,
            timeout: {enter: 500, exit:500}
        };

        // make sure the fish are loaded (from Firebase) before continue
        if (!fish) return null;

        if (!isAvailable) {
            return (
                <CSSTransition
                    // classNames="order"
                    // key={key}
                    // timeout={{enter: 500, exit:500}}
                    {...TransitionOptions}
                >
                <li key={key}>Sorry {fish ? fish.name : "fish"} is no longer available.</li>
                </CSSTransition>
            );
        }
        return   (
            <CSSTransition
                // classNames="order"
                // key={key}
                // timeout={{enter: 500, exit:500}}
                {...TransitionOptions}
            >
                <li key={key}>
                    <span>
                        <TransitionGroup component="span" className="count">
                            <CSSTransition
                                classNames="count"
                                key={count}
                                timeout={{enter: 500, exit: 500}}
                            >
                                <span>{count}</span>
                            </CSSTransition>
                        </TransitionGroup>

                        lbs {fish.name}
                        {formatPrice(count * fish.price)}
                        <button onClick={() => this.props.removeFromOrder(key)}>&times;</button>
                    </span>
                </li>
            </CSSTransition>
        )
    };

    render() {
        const orderIds = Object.keys(this.props.order);
        // reduce() is like a for loop or map but return a tally
        // see his Javascript 30 courses for more on reduce, filter and map
        // Array Cardio Day 1 and Array Cardio Day 2
        const total = orderIds.reduce((prevTotal, key) => {
            const fish = this.props.fishes[key];
            const count = this.props.order[key];
            const isAvailable = fish && fish.status === 'available';
            // if available
            if (isAvailable) {
                return prevTotal + (count * fish.price);
            }
            // if not just return prevTotal
            return prevTotal;

        }, 0); // reduce requires a starting value: 0

        return (
            <div className="order-wrap">

                <h2>Order</h2>
                {/*<ul className="order">*/}
                    {/*{ orderIds.map(this.renderOrder) }*/}
                {/*</ul>*/}
                {/*replace above with below to add transitions */}

                <TransitionGroup component="ul" className="order">
                    { orderIds.map(this.renderOrder) }
                </TransitionGroup>

                <div className="total">
                    Total:
                    <strong> {formatPrice(total)} </strong>
                </div>
            </div>
        )
    }
}

export default Order;

// NOTES
// this { orderIds.map(this.renderOrder) }
// was this {orderIds.map(key => <li>{key}</li>)}
// simplified by making the separate renderOrder function
//
// on this <li key={key}> that key is needed so React can find it faster
//
// CSSTransition and Stylus
// in package.json there is this:
// "styles": "stylus -u autoprefixer-stylus ./src/css/style.styl -o ./src/css/style.css",
// "styles:watch": "stylus -u autoprefixer-stylus -w ./src/css/style.styl -o ./src/css/style.css"
// so to compile the CSS
// in terminal:  npm run styles:watch
// to run more than one thing at once, there is this:
// "watch": "concurrently --names \"webpack, stylus\" --prefix name \"npm run start\" \"npm run styles:watch\"",
// so in terminal: npm run watch
//
// why the double brackets {{ }} on this: timeout={{enter: 5000, exit: 5000}} ?
// the outside set is for "this is Javascript"
// the inside is an "object literal"
// see: https://gist.github.com/jacob-beltran/7777a477942cbb2c9db65a1e3c312e88




// WEBPACK FOOTER //
// ./src/components/Order.js